var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 124,
    viewBox: "0 0 137 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.918 25.7124H114.875V33.7142H132.918C135.134 33.7142 136.93 31.9229 136.93 29.7133C136.93 27.5037 135.134 25.7124 132.918 25.7124Z",
    fill: "#221E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2464 12.8562H93.3906V46.5704H94.2464C101.221 46.5704 106.852 40.9433 106.852 33.9988V25.4278C106.852 18.598 101.315 12.8562 94.2464 12.8562Z",
    fill: "#221E3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7616 0H21.199C9.47088 0 0 9.4704 0 21.1426V55.4258C0 57.6354 1.79613 59.4267 4.01161 59.4267H72.7616C79.7359 59.4267 85.3671 53.8001 85.3671 46.8551V12.5716C85.3671 5.74156 79.8306 0 72.7616 0ZM25.2108 38.2841C25.2108 40.4936 23.4147 42.285 21.1992 42.285C18.9838 42.285 17.1876 40.4936 17.1876 38.2841V21.1424C17.1876 18.9328 18.9838 17.1415 21.1992 17.1415C23.4147 17.1415 25.2108 18.9328 25.2108 21.1424V38.2841ZM42.3982 38.2841C42.3982 40.4936 40.6021 42.285 38.3866 42.285C36.1711 42.285 34.375 40.4936 34.375 38.2841V21.1424C34.375 18.9328 36.1711 17.1415 38.3866 17.1415C40.6021 17.1415 42.3982 18.9328 42.3982 21.1424V38.2841Z",
    fill: "#4A3A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7461 80.8536H59.8727C62.0882 80.8536 63.8844 79.0623 63.8844 76.8527V67.4285H55.1299L49.7461 80.8536Z",
    fill: "#221E3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2762 94.279C47.7762 94.279 44.5155 92.5539 42.5539 89.6644C40.5916 86.7747 40.1966 83.1141 41.4964 79.8729L46.4874 67.4285H11.6241C11.5807 68.25 11.4066 69.0702 11.0916 69.856L2.13097 92.1975C0.717009 95.722 0 99.4346 0 103.232V119.707C0 121.916 1.79613 123.708 4.01161 123.708H51.2772C53.4927 123.708 55.2889 121.916 55.2889 119.707V98.2799C55.2889 96.0704 53.4919 94.279 51.2762 94.279Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerTools);
export default __webpack_public_path__ + "static/media/power_tools.d48cddf4d3f8bbe8a113c3330ec66ad2.svg";
export { ForwardRef as ReactComponent };